import FieldSelect from '../../configuration/fields/FieldSelect';
import FieldText from './FieldText';
import FieldTextArea from './FieldTextArea';
import FieldSingleSearchDropdown from './FieldSingleSearchDropdown';

const renderField = function (field, isEditable, possibleToEdit, onEditButtonClick, customeClassName = '', setDirty) {

    return (
        <div className="configuration-editor-info-card-field">
            <div className="configuration-editor-info-card-field-label">{field.label}</div>
            <div className="configuration-editor-info-card-field-value" style={{display: 'Flex', alignItems: 'center'}}>
                {renderInput(field, isEditable, customeClassName, setDirty)}
                {possibleToEdit &&
                    <div style={{marginLeft: '10px'}} onClick={() => onEditButtonClick(field)}>
                        {isEditable ? (
                            <svg viewBox="0 0 612 612" width="12px" height="12px" style={{cursor: 'pointer'}}>
                                <g>
                                    <polygon
                                        points="573.75,0 183.485,516.968 37.657,380.702 0,422.548 189.452,612 612,38.843"
                                        fill="#9DA4B3"/>
                                </g>
                            </svg>
                        ) : (
                            <svg viewBox="0 0 512 512" width="12px" height="12px" style={{cursor: 'pointer'}}>
                                <g>
                                    <path
                                        d="M328.883,89.125l107.59,107.589l-272.34,272.34L56.604,361.465L328.883,89.125z M518.113,63.177l-47.981-47.981   c-18.543-18.543-48.653-18.543-67.259,0l-45.961,45.961l107.59,107.59l53.611-53.611   C532.495,100.753,532.495,77.559,518.113,63.177z M0.3,512.69c-1.958,8.812,5.998,16.708,14.811,14.565l119.891-29.069   L27.473,390.597L0.3,512.69z"
                                        fill="#9DA4B3"/>
                                </g>
                            </svg>
                        )}
                    </div>}
            </div>
        </div>
    )
}

export default renderField;

function renderInput(field, isEditable, customeClassName, setDirty) {
    if (field.type === 'select')
        return renderSelect(field, isEditable, setDirty)

    if (field.type === 'text')
        return isEditable ? <FieldText field={field} onChange={value => {
            field.value = value;
            setDirty()
        }} customClassName={customeClassName}/> : renderMutedField(field.value)

    if (field.type === 'textarea')
        return isEditable ? <FieldTextArea field={field} onChange={value => {
            field.value = value;
            setDirty();
        }}/> : renderMutedField(field.value)

    if (field.type === 'searchsingleselect')
        return isEditable ? <FieldSingleSearchDropdown field={field} onOptionClick={value => {
            field.value = value;
            setDirty();
        }}/> : renderMutedBySelect(field)

    return '';
}


function renderMutedField(value) {
    if (typeof value === 'undefined' || value === null) {
        return <span className="text-muted">{__('None')}</span>
    }

    return <span>{value}</span>
}

function renderSelect(field, isEditable, setDirty) {
    const onChange = value => {
        field.value = value;
        setDirty();
    }

    if (!isEditable) {
        return renderMutedBySelect(field)
    }


    return <FieldSelect
        items={field.items}
        value={field.value}
        forceReadable={false}
        forceNonPortal={true}
        readonly={field.readonly}
        onChange={onChange}/>
}

function renderMutedBySelect(field) {
    var selected = field.items.find(x => x.value == field.value)
    var text = selected ? selected.text : ''
    return renderMutedField(text)
}